import React from 'react';
import {
  faPen,
  faTrash,
  faEye
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PhotographIcon } from '@heroicons/react/outline';
import ActionConfirmForm from '../common/ActionConfirmForm';
import './BrandingItem.scss';

const ReactSwal = withReactContent(Swal);

const BrandingItem = props => {
  const onDeleteBrandingItem = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <ActionConfirmForm
          onConfirm={ReactSwal.clickConfirm}
          onClose={ReactSwal.clickCancel}
          title="Delete Branding"
          question={`Are you sure you want to delete this ${props.data.name} branding option?`}
        />
      )
    })
    .then(async result => {
      if (result.value) {
        props.onDelete();
      }
    });
  };

  const renderImage = (src, alt) => {
    return src ? (
      <img src={src} alt={alt} onError={(e) => { e.target.style.display = 'none'; }} />
    ) : (
      <PhotographIcon className="missing-image-icon" aria-label="Missing image icon" />
    );
  };

  return (
    <div className={`branding-item${props.data.default ? ' default ' : ''}`}>
      <div className="branding-name">{props.data.name}</div>
      <div className="branding-content">
        <div className="branding-item-content">
          <div className="branding-image logo" title="Logo">
            {renderImage(props.data.logo, "logo")}
          </div>
          <div className="branding-image favicon" title="Favicon">
            {renderImage(props.data.favicon, "favicon")}
          </div>
          <div
            className="branding-color"
            style={{ backgroundColor: props.data.color }}
            title="Branding Color"
          ></div>
          <div className="branding-image siteimage" title="Site Image">
            {renderImage(props.data.siteImage, "Site")}
          </div>
        </div>
        <div className="actions">
          <FontAwesomeIcon onClick={props.onPreview} icon={faEye} />
          <FontAwesomeIcon onClick={props.onEdit} icon={faPen} />
          <FontAwesomeIcon onClick={onDeleteBrandingItem} icon={faTrash} />
        </div>
      </div>
    </div>
  )
}

export default BrandingItem;
